import { ButtonLink, ButtonLinkProps } from 'component-library';
import { ReactNode } from 'react';

import { TextContainer } from '../Text/Text';

type ButtonWidgetProps = {
  text?: string;
  i18nPath?: string;
  children?: ReactNode;
} & ButtonLinkProps;

export const ButtonLinkWidget = ({ text, i18nPath, children, ...props }: ButtonWidgetProps) => {
  return (
    <ButtonLink {...props}>
      <TextContainer {...{ text, i18nPath, children }} />
    </ButtonLink>
  );
};
